import React from "react";
import loadable from "@loadable/component";
import Loader from "../Loader";

export default loadable(() => import("./ComposerCard"), { fallback: <Loader margin="auto" /> });
